import { useLocalization } from '~/framework';
import { Stack, Flex, Text } from '@chakra-ui/react';
import { useQuizSessionsContext } from '../QuizSessionsContext';

export function Filters() {
   const { _js } = useLocalization();
   const { filters, filterManagement } = useQuizSessionsContext();

   const isFilterByTeamEnabled = filters.team !== undefined;
   const isFilterShowMyQuizzesEnabled = filters.showMyQuizzes !== undefined;
   const filterBorderColor = (enabled: boolean) => (enabled ? '#1570F0' : '#D2D5DA');
   const filterTextColor = (enabled: boolean) => (enabled ? '#1570F0' : '#1F2937');
   const filterBackgroundColor = (enabled: boolean) =>
      enabled ? 'rgba(21, 112, 240, 0.1)' : '#FFF';

   return (
      <Stack direction="row" spacing="2">
         <Flex align="center">
            <Text color="#6E7881">{_js('Filters: ')}</Text>
         </Flex>
         <Flex
            borderRadius="3xl"
            border="1px"
            gap="6"
            borderColor={filterBorderColor(isFilterByTeamEnabled)}
            cursor="pointer"
            backgroundColor={filterBackgroundColor(isFilterByTeamEnabled)}
            onClick={filterManagement.team.handle}
         >
            <Text py="2" px="4" color={filterTextColor(isFilterByTeamEnabled)}>
               {filters?.team?.name || filterManagement.team.label}
            </Text>
         </Flex>
         <Flex
            borderRadius="3xl"
            border="1px"
            gap="6"
            borderColor={filterBorderColor(isFilterShowMyQuizzesEnabled)}
            cursor="pointer"
            backgroundColor={filterBackgroundColor(isFilterShowMyQuizzesEnabled)}
            onClick={filterManagement.showMyQuizzes.handle}
         >
            <Text py="2" px="4" color={filterTextColor(isFilterShowMyQuizzesEnabled)}>
               {filterManagement.showMyQuizzes.label}
            </Text>
         </Flex>
      </Stack>
   );
}
